import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSeo } from "@/lib/seo";
import { useSettings } from "@/context/SettingsContext";
import Newsletter from "@/components/public/Newsletter";
import { Reveal } from "@/components/public/Reveal";
import { BrushUnderline } from "@/components/public/Brush";

export default function About() {
  const { settings } = useSettings();
  useSeo({ title: "About | Lucrative Laptop", description: "Lucrative Laptop is a publication for regular people building something of their own." });

  const values = [
    { n: "01", t: "Built From Experience", d: "I've tried different ideas, built online projects, tested what works, and learned plenty from what didn't. LucrativeLaptop is where I share what I pick up along the way." },
    { n: "02", t: "Ideas Worth Trying", d: "I'm always looking for creative ways to build, promote, and grow something online. When I find an idea worth exploring, I break it down here so you can try it too." },
    { n: "03", t: "Test. Learn. Share.", d: "I don't want this to be another blog repeating the same business advice. I create, experiment, research, test tools and strategies, then turn what I learn into content you can actually use." },
    { n: "04", t: "No Guru Energy", d: "No pretending I have everything figured out. No overnight-success talk. Just real ideas, useful tools, lessons from experience, and different ways to keep moving forward." },
  ];

  return (
    <div className="max-w-[1200px] mx-auto px-5 lg:px-10 pt-12 pb-12">
      <div className="relative mb-16">
        <div className="flex items-center gap-3 mb-5"><span className="w-6 h-0.5 bg-brand" /><span className="label-mono">About</span></div>
        <h1 className="font-poster uppercase text-white leading-[0.86] text-6xl lg:text-8xl">
          I TRY THE IDEAS.<br /><span className="relative inline-block text-brand">I SHARE WHAT I LEARN.<BrushUnderline className="absolute left-0 -bottom-3 w-full h-5 text-brand" /></span>
        </h1>
        <p className="text-white/65 text-lg mt-8 max-w-2xl leading-relaxed">
          I'm Edriis Franklin, the person behind LucrativeLaptop. This is where I share the ideas, experiments, tools, strategies, and lessons that come from actually creating and trying things online. I'm building and learning too, so when I find something useful, I pass it along for whatever you're working on.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 gap-6 mb-16">
        {values.map((v, i) => (
          <Reveal key={v.n} delay={i * 0.06}>
            <div className="relative border border-ink-600 texture-concrete p-8 h-full edge-card overflow-hidden">
              <span aria-hidden="true" className="absolute -top-4 right-3 font-poster text-stroke text-6xl opacity-50">{v.n}</span>
              <h3 className="font-display font-bold uppercase text-white text-2xl mb-3">{v.t}</h3>
              <p className="text-white/60 leading-relaxed">{v.d}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="relative border border-ink-600 texture-concrete p-10 lg:p-16 mb-14 text-center overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1.5 bg-brand" />
        <p className="font-hand text-brand text-3xl mb-4 rotate-[-1.5deg]">Good ideas deserve a shot.</p>
        <h2 className="font-poster uppercase text-white text-3xl lg:text-5xl leading-[0.95]">NOT SURE WHERE TO BEGIN?</h2>
        <Link to="/start-here" className="btn-poster mt-8"><span>START HERE</span><ArrowRight size={17} className="relative z-10" /></Link>
      </div>

      <Newsletter headline={settings.newsletter_headline} subtext={settings.newsletter_subtext} />
    </div>
  );
}
